var map = {
	"./btn-add-bg.jpg": 80224,
	"./howWork-1-wap.jpg": 41140,
	"./howWork-1.jpg": 87107,
	"./index-head-bg-h5.jpg": 82013,
	"./index-head-bg.jpg": 2025,
	"./referral-total-bg1.jpg": 30577,
	"./referral-total-bg2.jpg": 89158,
	"./reward/mining-q-1.jpg": 32448
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16065;